import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

import { getShipement, deleteShipementInServer, updateShipmentInServer } from "../helpers/requests";
import { iconColors } from "../helpers/scripts";


import ModuleShipment from '../components/ModuleShipment'
import ModuleOrder from '../components/ModuleOrder'
import ModuleNotification from '../components/ModuleNotification'


import { Divider, Button, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ShipmentDetails = () => {

    let lacation = useLocation()
    const navigate = useNavigate()

    const params = useParams()
    const shipmentID = params.shipmentID

    const [shipment, setShipment] = useState({})
    const [open, setOpen] = useState(false);


    const updateShipment = (e)=>{
        let key = e.target.name
        let value = e.target.value

        if( key === 'step_id' && value === 4 ){
            setShipment({...shipment, [key]:value, ['isDelivery']:true })
        } else {
            setShipment({...shipment, [key]:value})

        }

    }


    const deleteShipement = async () => {
        const rs = await deleteShipementInServer(shipment.id)
        if (rs){
            console.log(rs)
            navigate('/shipments/')
        }
    }

    const updateServer = async (close)=>{
        try {
            const rs = await updateShipmentInServer(shipment)
            console.log(rs)
            
            if (rs){
                setOpen(true);
            }
            if (close === true) {
                navigate(`/shipments/`) 
            }

        } catch (error) {
            console.log(error)   
        }

    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen(false);
    }



    useEffect(() => {

        const ff = async () => {
            setShipment({ ...await getShipement(shipmentID) })
        }

        if (lacation?.state?.id) {
            setShipment({ ...lacation.state })
            console.log(lacation.state)
        } else {
            ff()
        }
    }, [])

    return (
        <div>

            <Divider sx={{ mb: 2 }} />

            <div style={{display:'flex', justifyContent:'space-between'}}>
                <div >
                    <Button
                        size='small'
                        variant='outlined'
                        sx={{ mr: 4 }}
                        onClick={()=>{navigate('/shipments')}}
                        >
                        К списку отправок</Button>
                </div>
                <div style={{marginRight:0, marginLeft:'auto'}}>
                <Button 
                    variant='outlined' 
                    size='small'
                    sx={{marginRight:4}}
                    onClick={()=>deleteShipement(shipment.id)}
                    >Удалить доставку
                </Button>

                <Button 
                    variant='outlined' 
                    size='small'
                    sx={{marginRight:4}}
                    onClick={()=>updateServer(false)}
                    >Записать
                </Button>

                <Button 
                    variant='outlined' 
                    size='small'
                    sx={{marginRight:3}}
                    onClick={()=>updateServer(true)}
                    >Записать и закрыть
                </Button>         
                </div>
                <CloseIcon 
                    sx={{color:iconColors.blue, cursor:'pointer', mt:'2px' }}
                    onClick={  ()=>{navigate('/shipments')}} />
            </div>


            {shipment?.id ? <ModuleShipment shipment={shipment} updateShipment={updateShipment} /> : ''}

            {shipment?.shipment_notifications?.length > 0 ? shipment.shipment_notifications.map((notif) => <ModuleNotification key={notif.id} data={notif} />) : ''}

            {shipment?.order_data ? shipment.order_data.map((order) => <ModuleOrder key={order.id} order={order} updateOrder={false} setOrder={false} />) : ''}

            {shipment?.order_notifications ? shipment.order_notifications.map((notif) => <ModuleNotification key={notif.id} data={notif} />) : ''}


            <Snackbar
                    open={open}
                    autoHideDuration={3000}
                    onClose={handleClose}
                    message='Доставка обновлена'
                />

        </div>
    );
}

export default ShipmentDetails;
